const DATA_TO_REFRESH = {
  all: "ALL",
  contractorList: "CONTRACTOR_LIST",
  projContractorList: "PROJECT_CONTRACTOR_LIST",
  projLaborList: "PROJECT_LABOR_LIST",
  projLaborCrewList: "PROJECT_LABOR_CREW_LIST",
  projEquipList: "PROJECT_EQUIPMENT_LIST",
  projItemList: "PROJECT_ITEM_LIST",
  projCcoList: "PROJECT_CO_LIST",
  keywordList: "KEYWORD_LIST",
  projKeywordList: "PROJECT_KEYWORD_LIST",
  projLocationList: "PROJECT_LOCATION_LIST",
  projPendingIssueList: "PROJECT_PENDING_ISSUE_LIST",
  projStaffList: "PROJECT_STAFF_LIST",
  projAssignmentHistoryList: "PROJECT_ASSIGNMENT_HISTORY_LIST",
  projUnitList: "PROJECT_UNIT_LIST",
  userProjectRoles: "USER_PROJECT_ROLES",
  dailyReportList: "DAILY_REPORT_LIST",
  dailyReport: "DAILY_REPORT",
  dailyReportClarificationComments: "DAILY_REPORT_CLARIFICATION_COMMENTS",
  dailyReportCorrectionComments: "DAILY_REPORT_CORRECTION_COMMENTS",
  userList: "USER_LIST",
};

export default DATA_TO_REFRESH;
